<template lang="html">
    <div class="z-input-stock-zones" v-loader-overlay="progress">
        <autocomplete
            ref="search" 
            v-model="search" property="name" return="id" label="Добавить направление" display-property="name" v-bind:show-save-btn="true"
            v-on:select="selectZone" v-on:save="addZoneToStock" v-bind:callback="getZones" v-on:clear="clearSelectedZone"
        ></autocomplete>

        <div v-if="stockZones && stockZones.length" class="z-input-stock-zones__cities-list-container">
            <div class="z-input-stock-zones__cities-label">{{ `Прикреплённые направления (${stockZones.length})` }}</div>
            <div class="z-input-stock-zones__cities-list can-scroll">
                <div v-for="item in stockZones" v-bind:key="item.id" class="z-input-stock-zones__cities-item">
                    <div class="value">{{ (item.value) ? item.value : item.name }}</div>
                    <div class="actions">
                        <md-button @click.stop="showRemoveDialog(item)" class="md-icon-button md-dense small">
                            <md-icon>delete</md-icon>
                        </md-button>
                        <md-tooltip md-direction="top">Открепить направление</md-tooltip>
                    </div>
                </div>
            </div>
        </div>
        <md-dialog-confirm
            :md-active.sync="removeDialog"
            md-title="Открепить направление от склада?"
            md-content="Внимание! Действие необратимо!"
            md-confirm-text="Удалить"
            md-cancel-text="Отмена"
            v-on:md-cancel="removeDialog = false; zoneIdToRemove = null;" 
            v-on:md-confirm="removeZoneFromStock"
        ></md-dialog-confirm>
    </div>
</template>
<script>
    import Autocomplete from '@/components/autocomplete'
    export default {
        name: 'z-input-stock-zones',
        components: {Autocomplete},
        props: {
            stock: {
                type: Object,
                default: () => {
                    return {
                        id: null,
                        city: {},
                        city_id: null,
                        description: null,
                        freight_count: 0,
                        name: null,
                        printers: [],
                        responsibles: [],
                        sort: 100,
                        created_at: null,
                        updated_at: null,
                    };
                }
            },
        },
        data() {
            return {
                loadKey: 'load-stock-zones-card',
                search: '',
                selectedZone: {},
                stockZones: [],
                removeDialog: false,
                zoneIdToRemove: null
            }
        },
        created() {
            this.$nextTick(() => this.init());
        },
        watch: {
            '$props.stock'() {
                this.$nextTick(() => this.init());
            }
        },
        computed: {
            progress() {
                return this.progressObj[this.loadKey];
            },
            progressObj() {
                return this.$store.state.progressObj;
            }
        },
        methods: {
            init() {
                this.getStockZones();
                if (this.$refs.search) this.$refs.search.onClear();
            },
            getStockZones() {
                if (!this.$props.stock || !this.$props.stock.id) return;
                this.$store.commit('showProgressBar', this.loadKey);
                return this.$store.dispatch('stock/getStockZones', this.$props.stock.id).then(r => {
                    if (r && r.length) this.stockZones = Object.assign([], r);
                    else this.stockZones = [];
                }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
            },
            getZones(searchString) {
                if (searchString.length >= 3) return this.$store.dispatch('stock/getZones', { name: searchString }).then(r => {
                    if (!r || !r.length) return [];
                    return r
                });
            },
            clearSelectedZone() {
                this.selectedZone = Object.assign({}, {});
            },            
            selectZone(id, zone) {
                this.selectedZone = Object.assign({}, zone);
            },
            showRemoveDialog(zone) {
                this.removeDialog = true;
                this.zoneIdToRemove = zone.id;
            },
            addZoneToStock() {
                if (!this.selectedZone || !this.selectedZone.id) return;
                if (!this.stock || !this.stock.id) {
                    this.stockZones.push(this.selectedZone);
                    if (this.$refs.search) this.$refs.search.onClear();
                } else {
                    this.$store.commit('showProgressBar', this.loadKey);
                    return this.$store.dispatch('stock/addZoneToStock', { stock_id: this.stock.id, zone_id: this.selectedZone.id}).then(r => {
                        if (this.$refs.search) this.$refs.search.onClear();
                        this.getStockZones();
                    }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
                }
            },
            removeZoneFromStock() {
                if (!this.zoneIdToRemove) return
                if (!this.stock || !this.stock.id) {
                    const index = this.stockZones.findIndex(zone => parseInt(this.zoneIdToRemove) === parseInt(zone.id));
                    if (index > -1) this.stockZones.splice(index, 1);
                } else {
                    this.$store.commit('showProgressBar', this.loadKey);
                    return this.$store.dispatch('stock/deleteZoneToStock', { stock_id: this.stock.id, zone_id: this.zoneIdToRemove}).then(r => {
                        this.removeDialog   = false;
                        this.zoneIdToRemove = null;
                        this.getStockZones();
                    }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
                }
            }
        }
    }
</script>
<style lang="sass">
    .z-input-stock-zones
        width: 100%
    .z-input-stock-zones__input-container
        display: flex
        align-items: center
        justify-content: space-between
    .z-input-stock-zones__preview-city-danger
        display: flex
        align-items: center
        justify-content: flex-start
        color: red
        font-size: 12px
        line-height: 14px
        margin: 0 0 10px 0
        .md-icon
            color: red !important
            font-size: 22px !important
            margin: 0 5px 0 0
            width: 20px
            height: 20px
            min-height: 20px
            min-width: 20px
    .z-input-stock-zones__cities-list-container
        margin: 20px 0 10px 0
    .z-input-stock-zones__cities-list
        max-height: 600px
        overflow-y: auto
        .z-input-stock-zones__cities-label
            display: block
            font-size: 14px
            line-height: 16px
            margin: 0 0 10px 0
        .z-input-stock-zones__cities-item
            display: flex
            align-items: center
            justify-content: space-between
            margin: 0 0 5px 0
            padding: 2px 6px
            width: 100%
            border: 1px solid #BEBEBE
            box-sizing: border-box
            border-radius: 3px
            cursor: default
            &:hover
                background: #eee
            &:last-child
                margin: 0 0 0 0
            .value
                width: calc(100% - 30px)
                overflow: hidden
                text-overflow: ellipsis
                white-space: nowrap
            .actions
</style>


// WEBPACK FOOTER //
// ZInputStockZones.vue?73bb3720